import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BreadCrumbItem from './BreadCrumbItem';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const BreadCrumbs = ({ items }) => {
  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <ul className="breadcrumb">
            {items?.map((item, index) => (
              <Fragment key={index}>
                <BreadCrumbItem
                  active={items?.length - 1 === index}
                  className={classNames('breadcrumb-item', {
                    active: index === items.length - 1,
                  })}
                  to={item?.to}
                  label={item?.label}
                />
                {index < items.length - 1 ? (
                  <BreadCrumbItem className={`breadcrumb-item`}>
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </BreadCrumbItem>
                ) : null}
              </Fragment>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

BreadCrumbs.propTypes = {
  items: PropTypes.array.isRequired,
};

export default BreadCrumbs;
